// extracted by mini-css-extract-plugin
module.exports = {"bannersTab":"_24lBMGRyJPQWdip-kepwIw","bannerTextContainer":"QB-xxsF912o-Ib-6zWo7q","text":"_9Cynpzc3sYrTEnyHqmupH","heading":"_3VhtuxP761aLMsdDpjVr8j"};